import { Link } from "react-router-dom";
import Button from "../components/Button";
import EmptyState from "../components/ui/EmptyState";
import { assetUrl, formatPrice } from "../api/client";
import { useCart } from "../context/CartContext";
import fallbackCover from "../assets/Ebook.png";

export default function Cart() {
  const cart = useCart();

  return (
    <section className="section cart-page">
      <div className="container checkout-grid">
        <div>
          <span className="eyebrow">Shopping cart</span>
          <h1>Your Cart</h1>
          {!cart.items.length ? (
            <EmptyState
              title="Your cart is empty"
              text="Add a nutrition eBook to start checkout."
              action={<Button to="/shop">Browse Products</Button>}
            />
          ) : (
            <div className="cart-list">
              {cart.items.map((item) => (
                <article className="glass-card cart-item" key={item.id}>
                  <img src={assetUrl(item.image_url, fallbackCover)} alt={item.name} />
                  <div>
                    <Link to={`/products/${item.slug}`}><h3>{item.name}</h3></Link>
                    <p>{formatPrice(item.price)}</p>
                  </div>
                  <label>
                    <span>Qty</span>
                    <input type="number" min="1" value={item.quantity} onChange={(event) => cart.update(item.id, event.target.value)} />
                  </label>
                  <button className="text-button" type="button" onClick={() => cart.remove(item.id)}>Remove</button>
                </article>
              ))}
            </div>
          )}
        </div>
        <aside className="glass-card order-summary">
          <h2>Summary</h2>
          <div className="summary-lines">
            <div><span>Items</span><strong>{cart.count}</strong></div>
            <div><span>Subtotal</span><strong>{formatPrice(cart.subtotal)}</strong></div>
            <div className="summary-total"><span>Total</span><strong>{formatPrice(cart.subtotal)}</strong></div>
          </div>
          <div className="cart-actions">
            <Button to="/checkout" full disabled={!cart.items.length}>Checkout</Button>
            <Button to="/shop" variant="secondary" full>Continue Shopping</Button>
          </div>
        </aside>
      </div>
    </section>
  );
}
